import React, { useContext } from 'react';
import { CartContext } from '../../../context/CartContext';
import toast from 'react-hot-toast';

export default function MenuItemCard({ item, cartItem, isFavorite, onToggleFavorite, isHighlighted, onItemClick, browseMode = false, disabled = false  }) {
  const { addToCart, updateQuantity } = useContext(CartContext);

  // Minimal default customization
  const defaultCustomization = {
    customInstructions: '',
  };

  const handleCardClick = () => {
    if (browseMode || disabled) return;

    // Open items always delegate to parent (need price input modal)
    if (item.isOpenItem) {
      onItemClick(item);
      return;
    }

    // Check if item has variants
    const hasVariants = item.variants && item.variants.length > 0;

    // If item has variants or is being added for the first time, delegate to parent
    if (hasVariants || !cartItem) {
      onItemClick(item);
      return;
    }

    // Item already in cart - increment quantity directly
    updateQuantity(cartItem.cartId, cartItem.quantity + 1);
    toast.success(`${item.name} x${cartItem.quantity + 1}`, { duration: 1000 });
  };

  const hasVariants = item.variants && item.variants.length > 0;

  // Calculate price range for variants
  const getPriceDisplay = () => {
    if (item.isOpenItem) {
      return 'Open Price';
    }
    if (hasVariants) {
      const prices = item.variants.map(v => v.variantPrice);
      const minPrice = Math.min(...prices);
      const maxPrice = Math.max(...prices);
      if (minPrice === maxPrice) {
        return `₹${minPrice}`;
      }
      return `₹${minPrice} - ₹${maxPrice}`;
    }
    return `₹${item.price}`;
  };

  return (
    <div
      onClick={!disabled ? handleCardClick : undefined}
      className={`
        relative overflow-visible transition-all duration-150 border rounded-lg
        ${disabled
          ? 'bg-slate-100 border-slate-200 opacity-50 cursor-not-allowed'
          : browseMode
          ? 'bg-white border-slate-200 shadow-sm cursor-default'
          : isHighlighted
          ? 'bg-amber-50 border-amber-400 shadow-lg ring-2 ring-amber-300 scale-[1.02] cursor-pointer'
          : cartItem
          ? 'bg-teal-50 border-teal-400 shadow-md cursor-pointer'
          : 'bg-white border-slate-200 hover:border-teal-400 hover:shadow-md shadow-sm cursor-pointer'
        }
      `}
    >
      {/* Favorite Indicator - Small colored bar at top center */}
      {isFavorite && (
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-1 bg-gradient-to-r from-rose-400 via-rose-500 to-rose-400 rounded-b-full" />
      )}

      {/* Shortcut Key - Faded watermark style on right */}
      {item.shortcutKey && (
        <div className="absolute top-1 right-2 text-2xl font-bold text-slate-200 select-none pointer-events-none">
          {item.shortcutKey}
        </div>
      )}

      {/* Quantity Badge - Top Left Corner (half inside, half outside) */}
      {cartItem && !browseMode && (
        <div className="absolute -top-2 -left-2 bg-teal-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shadow-md z-10">
          {cartItem.quantity}
        </div>
      )}

      {/* Content */}
      <div className="px-4 py-3">
        {/* Item Name - Bold, 1rem */}
        <h3 className={`font-bold text-base leading-snug mb-1 line-clamp-2 ${
          cartItem ? 'text-teal-900' : 'text-slate-800'
        }`}>
          {item.name}
        </h3>

        {/* Category - Italic, smaller */}
        <p className={`text-xs italic mb-2 truncate ${
          cartItem ? 'text-teal-600' : 'text-slate-400'
        }`}>
          {item.category}
        </p>

        {/* {item.itemCode && (
  <p className="text-[10px] text-slate-400 mb-1 truncate">
    Code: {item.itemCode}
  </p>
)}
{item.barcode && (
  <p className="text-[10px] text-slate-400 mb-1 truncate">
    Barcode: {item.barcode}
  </p>
)} */}

        {/* Price */}
        <div className={`font-semibold ${cartItem ? 'text-teal-700' : 'text-slate-700'}`}>
          {getPriceDisplay()}
        </div>
      </div>
    </div>
  );
}
